import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import MobileSpecialistForm from './MobileSpecialistForm'

export default function MobileCreateSpecialistAppointmentPage ({ loading, onFinishFailed, sort, minimumAge, onFinish, civilityOptions, initialValues }) {
  return (
    <>
      <PublicSiderXS />
      <MobileSpecialistForm
        loading={loading}
        onFinishFailed={onFinishFailed}
        sort={sort}
        minimumAge={minimumAge}
        onFinish={onFinish}
        civilityOptions={civilityOptions}
        initialValues={initialValues}
      />
    </>
  )
}
